import { IconButton, InputAdornment, TextField } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

const MySearchField = ({ 
    label = "Search", 
    value = "", 
    onChange, 
    debounceTime = 300,
    ...props 
}) => {
    const [searchInput, setSearchInput] = useState(value);

    useEffect(() => {
        setSearchInput(value);
    }, [value]);

    // Debounce for search input
    useEffect(() => {
        const handler = setTimeout(() => {
            onChange(searchInput);
        }, debounceTime);

        return () => {
            clearTimeout(handler);
        };
    }, [searchInput, onChange, debounceTime]);

    return (
        <TextField
            label={label}
            value={searchInput}
            variant="outlined"
            fullWidth
            size="small"
            margin="dense"
            onChange={(e) => setSearchInput(e.target.value)}
            sx={{
                backgroundColor: "white",
            }}
            InputProps={{
                endAdornment: searchInput && (
                    <InputAdornment position="end">
                        <IconButton 
                            aria-label="clear search" 
                            onClick={() => setSearchInput("")} 
                            edge="end"
                        >
                            <GridCloseIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...props}
        />
    );
};

export default MySearchField;